
import { 
  BASE, 
  PREPAGO,
  CLIENT_APP_API ,
  PRODUCT_PERMINUTES, 
  PRODUCT_PREPAGO,
  PRODUCT_CUSTOM,
  PRODUCT_PRUEBA,
  PRODUCT_EXTRA
} from '@/config';


export default {

  /**
   * Check if a string is blank, null or undefined
   *
   * @param str string target
   */
  isBlank(str) {
    return !str || /^\s*$/.test(srt);
  },

  slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
      .replace(/[\u0300-\u036f]/g, ''); // Replace accentuated characters
  },

  formatStringPrice(value) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  },

  setThreeNumberDecimal(value) {
    let val = parseFloat(value).toFixed(3);
    return val;
  },

  dateTimeFormat(date) {
    return moment(date).format('DD/MM/YYYY hh:mm:ss')
  },

  dateFormat(date) {
    return moment(date).format('DD/MM/YYYY')
  },

  timeFormat(date) {
    return moment(date).format('hh:mm:ss')
  },
  timeHour(date) {
    return moment(date).format('HH:mm')
     // new Date(date).getHours();
  },

  validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  getParkingName(value){
    return value?.id === 1 ? 'BELLUGA'
      : value?.id === 2 ? 'MARQUINA'
        : value?.id === 3 ? 'LUCEROS' : value?.name
  },
  getReaderLabel(readerId) {
    return readerId == 1 ? 'ENTRADA'
    : readerId == 2 ? 'SALIDA'
      :   readerId == 3 ? 'PEATONAL' : readerId
  },
  getColorBadgeStatus( status ) {
    return status === 'ACTIVE' ? 'bg-gradient-warning'
      : status === 'CANCELLED' ? 'bg-gradient-danger'
        : status === 'FINISHED' ? 'bg-gradient-success' : 'bg-gradient-light'
  },
  getLabelStatus( status ) {
    return status === 'ACTIVE' ?  'Activo'
      : status === 'FINISHED' ? 'Finalizado'
        : status === 'CANCELLED' ?  'Cancelado'
          : status ==='NOT_ACTIVE' ? 'Activo (próximamante)' : ''
  },

  getStatusColor(status) {
    return status === 'ACTIVE' ? 'success'
      : status === 'CANCELLED' ? 'danger'
        : status === 'FINISHED' ? 'warning'
          : status ==='NOT_ACTIVE' ? 'info' :  'light'

  },

  getColorBadgePaymentStatus( status ) {
    return status === 'PENDING_PAYMENT' ? 'bg-gradient-warning'
      : status === 'CANCELLED' ? 'bg-gradient-danger'
        : status === 'PAID' ? 'bg-gradient-success' : 'bg-gradient-light'
  },
  getLabelPaymentStatus( status ) {
    return status === 'PAID' ?  'Pagado'
      : status === 'PENDING_PAYMENT' ? 'Pendiente'
        : status === 'CANCELLED' ?  'Cancelado' : ''
  },

  getProductLabel( product_type ){

    return product_type === 'extra' ?  'Pago Independiente'
      : product_type === 'base' ? 'Plan Base'
       : product_type === 'perminutes' ? 'Plan Base'
        : product_type === 'prepago' ?  'Plan Prepago'
          : product_type === 'custom' ?  'Plan Personalizado'
            : product_type === 'trial' ?  'Período Prueba' : product_type
  },

  getColorOcupationStatus( status ){
    return status === 'COMPLETO' ?  'danger'
      : status === 'ACCESIBLE' ? 'success' : 'warning'
  },

  // getIconProduct(product_type){
  //   return product_type === 'custom' ? 'cil-asterisk-circle' :
  //     product_type === 'prepago' ? 'cil-chart-pie' :
  //       product_type === 'base' || 'perminutes' ? 'cil-clock' : 
  //         product_type === 'extra' ? 'cil-star' : 
  //           product_type === 'trial' ? 'cil-gift' : 'cil-av-timer'
  // },

  getIconProduct(productType) {

    return productType === PRODUCT_CUSTOM.key ? 'cil-asterisk-circle' :
      productType === PRODUCT_PREPAGO.key ? 'cil-chart-pie' :
        productType === BASE.key || PRODUCT_PERMINUTES.key ? 'cil-clock' : 
          productType === PRODUCT_EXTRA.key ? 'cil-star' : 
            productType === PRODUCT_PRUEBA.key ? 'cil-gift' : 'cil-av-timer'
  },


  getIconEventTypeInvision(eventType) {

    const EVENT_TYPE_DETAIL = {
      'person': 'Persona', 
      'bicycle': 'Bicicleta' ,
      'motorcycle': 'Moto',
      'electric_scooter': 'Patinete eléctrico',
      'rider_bicycle': 'Conductor bicicleta',
      'rider_motorcycle': 'Conductor moto',
      'rider_scooter': 'Conductor patinete',
    }
    const DEFAULT = eventType ;
  
    return EVENT_TYPE_DETAIL[eventType] || DEFAULT
  
  },

  getDiscountName(value) {
    return value === 'Wallet' ? 'Wallet' :
      value.includes('Wallet') ? 'Wallet + Grupo descuento' : 'Grupo descuento'
  },

}
